var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[{'p-sticky': !_vm.isSticky, 'p-sticky__sticky-active': _vm.isSticky}],style:(_vm.wrapperStyles)},[_c('div',{class:[{'p-sticky__sticky-active__sticky': _vm.isSticky}],style:(_vm.stickyStyles)},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }